import {Select} from '@hconnect/common/components'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {TaskSource} from '../../types'

type Props = {
  value?: TaskSource
  onChange: (value: TaskSource | undefined) => void
}

export const TaskTypeField: React.FC<Props> = ({value, onChange}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const taskTypeOptions = useMemo(
    () =>
      Object.values(TaskSource).map((value) => ({
        value,
        label: t(`task.source.${value}`)
      })),
    [t]
  )

  return (
    <Select
      data-test-id={'select-field-task-type'}
      label={t('task.label.taskType')}
      disabled={true} // We only support one task type for now, so we don't allow changing it
      value={value}
      options={taskTypeOptions}
      onChange={onChange}
    />
  )
}
